import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dimmer, Loader, Segment, Header, Message, Button } from 'semantic-ui-react';

import { patients } from '../../actions/auth';
import { filterOrders } from '../../actions/exams';
import PatientsList from '../lists/PatientsList';
// import PatientCard from '../cards/PatientCard';
import PatientsDateFilter from '../filters/PatientsDateFilter';
import { setFilterRange, setLastFilteredPatients } from '../../actions/exams';

class PatientSection extends Component {
  state = {
    filteredPatients: [],
    allPatients: true,
    lastFilter: this.props.filterRange || {
      startDate: null,
      endDate: null,
      text: null
    },
    activeFilter: null,

  };

  componentDidMount() {
    //this.props.patients(this.props.user);
    console.log('THIS PROPS',this.props)
    if(!this.props.lastFilteredPatients || this.props.lastFilteredPatients.length === 0){
      this.props.patients(this.props.user)
    } else {
      this.setState({
        filteredPatients:[],
        allPatients:false,
        lastFilter: this.props.filterRange || this.state.lastFilter
      })
    }

  }
  onInputChange = e => {
    const filter = e.target.value;

    if (filter.length > 2) {
      const filteredPatients = this.props.patientsList.filter(patient => {
        return ( (patient.paciente || "").toUpperCase().includes(filter.toUpperCase()) ||
        (patient.cedula || "").includes(filter) ||
        (patient.no_historia || "").includes(filter) )
      });

      this.setState({ filteredPatients, allPatients: false });
    } else {
      this.setState({ filteredPatients: [], allPatients: true });
    }
  };

  handleAdvancedFilter = async ({ text, startDate, endDate }, reset = false) => {
    const payload = {
      search: text || null,
      fecha_inicio: startDate || null,
      fecha_fin: endDate || null,
      user: this.props.practitioner
    };
  
    const activeFilter = { text, startDate, endDate };
    this.setState( {
      lastFilter:{
        text,
        startDate,
        endDate
    }});
    this.props.setFilterRange(activeFilter);

    try {
      const filteredPatients = await this.props.filterOrders(payload);
      
      if (!Array.isArray(filteredPatients)) {
        console.warn("Resultado no es array:", filteredPatients);
        this.setState({ filteredPatients : [], allPatients: false });
        return;
      } 
      this.setState({ filteredPatients, allPatients: false })

      const currentFiltered = this.props.lastFilteredPatients || []; //aqui toma lo del filtro 
    
      const merged = [ 
        ...currentFiltered,
        ...filteredPatients.filter(
          np => !currentFiltered.some(cp => cp.cedula === np.cedula)
        )
      ];
     
      this.props.setLastFilteredPatients(merged);
      //this.setState({ filteredPatients, allPatients: false })
     

    } catch (error) {
      console.error("Error al filtrar pacientes:", error);
    }
  };

  returnToPatientsSearch = () => {
    
    this.setState({
      activeFilter:null,
      filteredPatients:[],
      allPatients: false
    });
  };

  render() {
    const { allPatients, filteredPatients, activeFilter } = this.state;
    const { listReady, patientsList } = this.props;

    return (
      <div>
        {!listReady ? (
          <Dimmer active inverted>
            <Loader>Cargando...</Loader>
          </Dimmer>
        ) : (
          <div>
            {patientsList.length === 0 ? (
              <Message
                info
                icon='info'
                header='Aún no tiene pacientes asociados a su perfil.'
              />
            ) : (
              <>
              {}
              <Segment>
                <Header as='h2'>Lista de pacientes</Header>
                <PatientsDateFilter 
                  onFilterSubmit={this.handleAdvancedFilter} 
                  initialFilter={this.state.lastFilter} 
                />
                {filteredPatients.length > 0 && (
                <PatientsList
                  //showPatientOrdersList={this.props.showPatientOrdersList}
                  showPatientOrdersList={(params) =>
                  this.props.showPatientOrdersList({
                    ...params,
                    filterRange: this.state.lastFilter
                  })
                }
                  practitioner={this.props.practitioner}
                  //patientsList={allPatients ? patientsList : filteredPatients}
                  //patientsList={filteredPatients.length > 0 ? filteredPatients : patientsList}
                  patientsList={filteredPatients.length > 0 ? filteredPatients : []}
                  filterRange={this.state.lastFilter}
                />
                )}
              </Segment>  
                {this.props.lastFilteredPatients.length > 0 && !activeFilter && (
                <Segment color='grey'>
                    <Header as='h4'>Consultas recientes:</Header>
                    <PatientsList 
                    showPatientOrdersList={(params) =>
                        this.props.showPatientOrdersList({
                          ...params,
                          filterRange: this.state.lastFilter
                        })
                      }
                    patientsList={this.props.lastFilteredPatients} 
                    practitioner={this.props.practitioner} />
                  </Segment>
              )}
           </> )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  patientsList: state.patients.patients || [],
  listReady: !!state.patients.patients,
  user: state.user,
  practitioner: state.practitioner,
  filterRange: state.examsByOrder.filterRange,
  lastFilteredPatients: state.examsByOrder.lastFilteredPatients || []
});

export default connect(
  mapStateToProps,
  { patients, filterOrders,setFilterRange,setLastFilteredPatients }
)(PatientSection);
